import { Injectable } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { EventSwitcherConfig } from '@frontend/sports/common/client-config-data-access';
import { ModalDialogOptions, ModalDialogService } from '@frontend/sports/modal/feature';
import { HtmlNode } from '@frontend/vanilla/core';

import { EventSwitcherTrackingService } from '../event-switcher-tracking.service';
import { EventSwitcherComponent } from '../event-switcher/event-switcher.component';
import { InputData } from '../models';
import { SwitcherToggleService } from './switcher-toggle.service';

@Injectable({ providedIn: 'root' })
export class EventSwitcherToggleService extends SwitcherToggleService {
    private readonly dialogCssClass = 'event-switcher-dialog';

    constructor(
        private trackingService: EventSwitcherTrackingService,
        eventSwitcherConfig: EventSwitcherConfig,
        dialogService: ModalDialogService,
        htmlNode: HtmlNode,
    ) {
        super(dialogService, htmlNode, eventSwitcherConfig.isEnabled);
    }

    override getHtmlToggleClass(): string {
        return 'event-switcher-visible';
    }

    openSwitcher(event: EventModel, inOverlay: boolean): void {
        const options: ModalDialogOptions<InputData> = {
            data: {
                event,
                inOverlay,
            },
            settings: {
                cssClass: this.dialogCssClass,
                backdropClass: this.dialogCssClass,
                scrollTargetQuerySelector: 'ms-event-switcher',
                fit: false,
            },
        };
        this.open(EventSwitcherComponent, options);
        this.trackingService.trackOpen(event.id);
    }
}
